<template>
  <div v-if="announcement" class="global-announcement-wrapper">
    <div class="global-announcement-spacer" :style="{ height: bannerHeight + 'px' }"></div>
    <div ref="banner" class="global-announcement-banner" :style="bannerStyle">
      <i class="bullhorn icon"></i>
      <span class="global-announcement-text">{{ announcement.message }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'global-announcement',

  data() {
    return {
      announcement: null,
      bannerHeight: 0
    }
  },

  computed: {
    bannerStyle() {
      if (!this.announcement) return {}
      return {
        backgroundColor: this.announcement.background,
        color: this.announcement.color,
        borderBottom: '1px solid ' + this.announcement.border,
      }
    }
  },

  mounted() {
    this.fetchAnnouncement()
    window.addEventListener('resize', this.updateHeight)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateHeight)
  },

  methods: {
    fetchAnnouncement() {
      this.axios.get('announcement').then(({data}) => {
        if (data && data.message) {
          this.announcement = data
          this.$nextTick(this.updateHeight)
        }
      }).catch(() => {
        // silently ignore — announcement is non-critical
      })
    },

    updateHeight() {
      if (this.$refs.banner) {
        this.bannerHeight = this.$refs.banner.offsetHeight
      }
    }
  }
}
</script>

<style scoped>
.global-announcement-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 600;
  z-index: 9999;
}

.global-announcement-text {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/GlobalAnnouncement.vue